import {
  TOGGLE_MODAL_OPEN,
  TOGGLE_POWER,
  SET_TIMER,
  SET_VOLTAGE,
  SET_CURRENT,
  ON_START,
  ON_STOP,
  ANIMATION_PLAYBACK_COMPLETE,
  ON_DROP_WIRE,

} from "../Redux.constants";

//---POWER SUPPLY------------------------------------------:

export const createPowerSupply = data => {
  //data = {id, description, type}
  return { type: "CREATE_POWER_SUPPLY", payload: data };
};


export const setPowerSupplyAnodeConnected = (data) => {
  //data = {anodeConnected}
  return { type: "SET_POWER_SUPPLY_ANODE_CONNECTED", payload: data }
}

export const setPowerSupplyCathodeConnected = (data) => {
  //data = {cathodeConnected}
  return { type: "SET_POWER_SUPPLY_CATHODE_CONNECTED", payload: data }
}

export const incPowerSupplyTime = (data) => {
  //data = {cathodeConnected}
  return { type: "INC_POWER_SUPPLY_TIME", payload: data }
}
export const decPowerSupplyTime = (data) => {
  //data = {cathodeConnected}
  return { type: "DEC_POWER_SUPPLY_TIME", payload: data }
}
export const countDownPowerSupplyTime = (data) => {
  //data = {cathodeConnected}
  return { type: "COUNT_DOWN_POWER_SUPPLY_TIME", payload: data }
}
export const resetPowerSupplyTime = (data) => {
  //data = {cathodeConnected}
  return { type: "RESET_POWER_SUPPLY_TIME", payload: data }
}
export const incPowerSupplyAmp = (data) => {
  //data = {cathodeConnected}
  return { type: "INC_POWER_SUPPLY_AMP", payload: data }
}
export const decPowerSupplyAmp = (data) => {
  //data = {cathodeConnected}
  return { type: "DEC_POWER_SUPPLY_AMP", payload: data }
}
export const incPowerSupplyWatt = (data) => {
  //data = {cathodeConnected}
  return { type: "INC_POWER_SUPPLY_WATT", payload: data }
}
export const decPowerSupplyWatt = (data) => {
  //data = {cathodeConnected}
  return { type: "DEC_POWER_SUPPLY_WATT", payload: data }
}
export const incPowerSupplyVoltage = (data) => {
  //data = {cathodeConnected}
  return { type: "INC_POWER_SUPPLY_VOLTAGE", payload: data }
}
export const decPowerSupplyVoltage = (data) => {
  //data = {cathodeConnected}
  return { type: "DEC_POWER_SUPPLY_VOLTAGE", payload: data }
}
export const togglePowerSupplyPower = (data) => {
  //data = {cathodeConnected}
  return { type: "SET_POWER_SUPPLY_POWER", payload: data }
}
export const togglePowerSupplyStart = (data) => {
  //data = {cathodeConnected}
  return { type: "SET_POWER_SUPPLY_ACTIVE", payload: data }
}

export const setCentrifugeRpm = (data) => {
  //data = {rpm}
  return { type: "SET_CENTRIFUGE_RPM", payload: data }
}

export const setCentrifugeTime = (data) => {
  //data = {time}
  return { type: "SET_CENTRIFUGE_TIME", payload: data }
}

export const toggleModalPs = (data) => {
  return { type: TOGGLE_MODAL_OPEN, payload: data }
}


export const togglePowerPs = (data) => {
  //data = {time}
  return { type: "TOGGLE_POWER_POWER_SUPPLY", payload: data }
}

export const setTimerPs = (payload) => {
  return { type: SET_TIMER, payload: payload }
}

export const setVoltagePs = (payload) => {
  return { type: SET_VOLTAGE, payload: payload }
}

export const setCurrentPs = (payload) => {
  return { type: SET_CURRENT, payload: payload }
}

export const onStartPowerSupplyPs = (data) => {
  return { type: ON_START, payload: data }
}

export const onStopPowerSupplyPs = (data) => {
  return { type: ON_STOP, payload: data }
}

export const animationPlaybackCompletePs = (data) => {
  return { type: ANIMATION_PLAYBACK_COMPLETE, payload: data }
}

export const onDropWirePs = (payload) => {
  { return { type: ON_DROP_WIRE, payload: payload } }
};